<!--
    FORM PARA SELECIONAR LOCAIS E LOTES PARA ALOCAR NO PEDIDO DE VENDA OU NA NOTA DE SAIDA
-->
<template>
<div class="container-fluid px-0 main-screen" style="font-size: 12.5px;">

  <!-- HEADER -->
  <div class="row mb-2" v-if="!excluir">
    <div class="col-12 text-right">
      <a @click="handleSugerirLotes" class="text-primary font-weight-bold" style="cursor: pointer; font-size: 12px;">
        Sugerir alocação automática
      </a>
    </div>
  </div>
  <div class="row mb-3" v-else>
    <div class="col-12">
      <h4 class="def-title" v-if="pedido"> Excluir Alocação do Pedido </h4>
      <h4 class="def-title" v-if="notafiscal"> Excluir baixa de estoque da nota fiscal </h4>
    </div>
  </div>

  <!-- GRID -->
  <div class="border rounded bg-white">
    <!-- Header -->
    <div class="row m-0 bg-light p-2 font-weight-bold" style="font-size: 12px; border-bottom: 1px solid #e3e6ea;">
      <div class="col-7">Item</div>
      <div class="col-2 text-right">Qt</div>
      <div class="col-2 text-right">Alocado</div>
      <div class="col-1"></div>
    </div>

    <!-- Rows -->
    <div v-for="(item, indexItem) in itemList" :key="item.coditem || indexItem" class="row m-0 p-2 border-bottom align-items-center">
      <!-- ITEM -->
      <div class="col-7">
        <div class="font-weight-bold">
          {{ item.codigo }} - {{ item.descricao }}
        </div>
        <div class="text-muted" style="font-size: 10px;" v-if="item.linha || item.coluna">
          {{ item.linha }} {{ item.coluna }}
        </div>
      </div>

      <!-- QT -->
      <div class="col-2 text-right font-weight-bold">
        {{ item.qt }}
      </div>

      <!-- ALOCADO -->
      <div class="col-2 text-right">
        <span class="badge"
              :class="isAlocated(item) ? 'badge-success bg-success text-white' : 'badge-warning bg-warning text-dark'"
              style="padding: 4px 8px; border-radius: 10px;">
          {{ qtAlcoated(item) }}
        </span>
      </div>

      <!-- ACTION -->
      <div class="col-1 text-center">
        <button v-if="!excluir" class="btn btn-primary btn-sm rounded p-0 d-flex justify-content-center align-items-center" style="width: 24px; height: 24px; margin: 0 auto;" @click="openModal(item)">
          <i class="fa fa-plus" style="font-size: 10px;"></i>
        </button>
      </div>

      <!-- ALOCAÇÕES -->
      <div class="col-12 mt-2 d-flex flex-wrap" style="gap: 4px;">
        <div v-if="item.validacao && item.validacao.length > 0" class="w-100 mb-1">
          <i class="fa fa-exclamation-circle text-danger" style="font-size: 14px"
             data-toggle="tooltip" data-placement="top" :title="item.validacao[0]"></i>
          <span class="text-danger ml-1" style="font-size: 11px;">{{ item.validacao[0] }}</span>
        </div>

        <div v-for="(e, i) in item.estoque" :key="i" v-if="!e.excluido"
             class="d-flex align-items-center bg-light border rounded px-2 py-1" style="font-size: 11px;">
          <span class="text-secondary mr-2">
            {{ labelEstoque(e) }}
          </span>
          <span class="font-weight-bold mr-2">
            {{ e.qt }}
          </span>
          <i v-if="!excluir" class="fa fa-times text-danger" style="cursor: pointer;"
             @click="remove(item, i)">
          </i>
          <div v-if="e.validacao && e.validacao.length" class="ml-2">
             <i class="fa fa-exclamation-circle text-danger" :title="e.validacao[0]" data-toggle="tooltip"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ALERTAS -->
  <alert v-if="msgErro" type="error" :text="msgErro" class="mt-3"/>
  <alert v-if="msgConcluir" type="warning" :text="msgConcluir" class="mt-3"/>

  <!-- EXCLUSAO CHECKBOX -->
  <div class="row mt-3" v-if="excluir">
    <div class="col-12 mb-2">
      <input-checkbox ref="confirmar" label="Clique aqui para confirmar a exclusão" v-model="exclusaoConfirmada"
        value-checked="S" value-unchecked="N"></input-checkbox>
    </div>
  </div>

  <!-- FOOTER -->
  <div class="row mt-4">
    <div class="col-12 d-flex justify-content-end" style="gap: 8px;">
      <template v-if="!excluir">
        <v-button :label="concluir ? 'Concluir' : 'Validar Estoque'" @click="handleSalvar" :nb-btdef="true"/>
        <v-button label="Fechar" @click="closeForm" :nb-btdef="false"/>
      </template>
      <template v-else>
        <v-button label="Confirmar Exclusão" @click="handleExcluir" :nb-btdef="true"/>
        <v-button label="Fechar" @click="closeForm" :nb-btdef="false"/>
      </template>
    </div>
  </div>

  <!-- MODAL -->
  <div v-if="modalVisible" class="modal d-block" tabindex="-1" role="dialog" style="background: rgba(0,0,0,0.5);">
    <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 550px; transition: all 0.3s ease;">
      <div class="modal-content" style="height: auto;">
        <div class="modal-header py-2 px-3">
          <h5 class="modal-title" style="font-size: 14px; font-weight: 600;">Selecionar lote / local</h5>
          <button type="button" class="close" @click="closeModal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body p-3">
          <!-- ITEM INFO -->
          <div class="mb-3 p-2 bg-light border rounded" v-if="selectedItem">
            <div class="font-weight-bold">{{ selectedItem.codigo }} - {{ selectedItem.descricao }}</div>
            <div class="d-flex justify-content-between mt-1" style="font-size: 11px;">
              <span>Total: <strong>{{ selectedItem.qt }}</strong></span>
              <span>Alocado: <strong>{{ qtAlcoated(selectedItem) }}</strong></span>
              <span class="text-primary">Pendente: <strong>{{ (selectedItem.qt - qtAlcoated(selectedItem)).toFixed(4) }}</strong></span>
            </div>
          </div>

          <div class="row m-0">
            <estoque-selecionar-lote
              v-if="selectedItem"
              :coditem="selectedItem.coditem"
              :coditemgrade="selectedItem.coditemgrade"
              :entrada="true"
              :filial="selectedItem.codfil"
              :obj="selectedEstoque"
              :depList="depositList"
              :somenteComQuantidade="true"
              @select="handleSeleciona"
            />
          </div>

          <!-- QUANTIDADE -->
          <div class="row mt-3 m-0">
            <form-field
              v-model.number="selectedEstoque.qt"
              type="value"
              col="12"
              label="Quantidade"
              :metadata="metadata.nfqt.qt"
              @keyup.enter="confirmAdd"
            />
          </div>

          <!-- ADICIONAR NOVO (FLUXO CONTÍNUO) -->
          <div v-if="selectedItem && selectedItem.estoque && selectedItem.estoque.length"
               class="mt-3">
            <button class="btn btn-light w-100" @click="resetSelecionar" style="font-size: 12px; background-color: #f4f6f9;">
              <i class="fa fa-plus mr-1"></i> Adicionar outro local
            </button>
          </div>
        </div>
        <div class="modal-footer py-2 px-3">
          <button type="button" class="btn btn-primary btn-sm" @click="confirmAdd">Confirmar</button>
          <button type="button" class="btn btn-light btn-sm" @click="closeModal">Cancelar</button>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import { apiORDS, apiORDSpost, apiORDSdelete } from '../shared/api-functions'
import EstoqueSelecionarLote from './estoque-selecionar-lote.vue';

export default {
  props: {
    index: { type: Number },
    notafiscal: { type: Boolean },
    pedido: { type: Boolean },
    excluir: { type: Boolean },
  },

  components: { EstoqueSelecionarLote },

  data() {
    return {
      metadata: this.$store.getters.getEntities.metadata,
      itemList: [],
      selectedItem: null,
      selectedEstoque: null,
      modalVisible: false,
      concluir: false,
      msgErro: null,
      msgConcluir: null,
      exclusaoConfirmada: 'N',
    }
  },

  computed: {
    depositList() {
      if (this.selectedItem && this.selectedItem.estoque) {
        return this.selectedItem.estoque.map(invent => invent.coddeposito)
      }
      return []
    },

    urlEstoque() {
      if (this.notafiscal && this.concluir)
        return `estoque/nfsaida/baixarestoque/${this.index}`

      if (this.notafiscal)
        return `estoque/nfsaida/${this.index}`

      if (this.pedido)
        return `estoque/pedidovenda/${this.index}`
    },

    urlSugestao() {
      if (this.notafiscal)
        return `estoque/nfsaida/sugerirestoque/${this.index}`

      if (this.pedido)
        return `estoque/pedidovenda/sugerirestoque/${this.index}`
    },

    urlExcluirEstoque() {
      if (this.pedido)
        return `estoque/pedidovenda/${this.index}/excluir`
      if (this.notafiscal)
        return `estoque/nfsaida/${this.index}/excluir`
    }
  },

  methods: {

    async loadData() {
      const r = await apiORDS(this.$store.getters.urlOrds + this.urlEstoque, null, true)
      this.itemList = r.items || r.itens || r
    },

    qtAlcoated(item) {
      if (!item || !item.estoque) return 0;
      return item.estoque.reduce((t, e) => {
        if (e.excluido) return t;
        return t + (e.qt || 0)
      }, 0)
    },

    isAlocated(item) {
      return this.qtAlcoated(item) === item.qt
    },

    openModal(item) {
      this.selectedItem = item
      this.resetSelecionar()
      this.modalVisible = true
    },

    resetSelecionar() {
      this.selectedEstoque = {
        ...this.$store.getters.getEntities.nfqt,
        qt: null,
        selecionarLote: true
      }
    },

    closeModal() {
      this.modalVisible = false
      this.selectedEstoque = null
    },

    confirmAdd() {
      if (!this.selectedEstoque || !this.selectedEstoque.qt) return

      if (!this.selectedItem.estoque) {
         this.$set(this.selectedItem, 'estoque', [])
      }

      this.selectedItem.estoque.push({
        ...this.selectedEstoque,
        selecionado: true,
        excluido: false
      })

      this.concluir = false
      this.msgConcluir = null

      // Check if fully allocated
      if (this.isAlocated(this.selectedItem)) {
        this.closeModal()
      } else {
        // Mantém aberto para fluxo rápido se ainda houver saldo
        this.resetSelecionar()
      }
    },

    remove(item, i) {
      if (item.estoque && item.estoque[i]) {
        if (!item.estoque[i].codnfqt) {
          item.estoque.splice(i, 1)
        } else {
          this.$set(item.estoque[i], 'excluido', true)
          this.$set(item.estoque[i], 'qt', 0)
        }
        this.concluir = false
        this.msgConcluir = null
      }
    },

    handleSeleciona(obj) {
      this.selectedEstoque = { ...this.selectedEstoque, ...obj }
      const pending = this.selectedItem.qt - this.qtAlcoated(this.selectedItem)
      if (pending > 0) {
        this.selectedEstoque.qt = obj.qt >= pending ? pending : obj.qt
      }
    },

    labelEstoque(e) {
      let l = []

      if (e.coddeposito) l.push(`Dep: ${e.descricao || e.coddeposito}`)
      if (e.local) l.push(`Local: ${e.local}`)
      if (e.linha || e.coluna) {
        let g = []
        if (e.linha) g.push(e.linha)
        if (e.coluna) g.push(e.coluna)
        l.push(`Grade: ${g.join('/')}`)
      }
      if (e.lote) l.push(`Lote: ${e.lote}`)
      if (e.sublote) l.push(`Sub: ${e.sublote}`)
      if (e.dtval) {
        let dtFormatada = e.dtval;
        if(typeof e.dtval === 'string' && e.dtval.indexOf('-') > 0) {
          let parts = e.dtval.split('T')[0].split('-');
          if(parts.length === 3) {
            dtFormatada = `${parts[2]}/${parts[1]}/${parts[0]}`;
          }
        }
        l.push(`Val: ${dtFormatada}`);
      }
      if (e.loteforn) l.push(`Forn: ${e.loteforn}`)

      return l.join(' | ')
    },

    async handleSugerirLotes() {
      this.msgErro = null
      this.msgConcluir = null
      this.concluir = false
      await apiORDSpost(this.$store, this.urlSugestao, null, 'put')
      this.loadData()
    },

    async handleSalvar() {
      let metodo = 'put'

      // Limpeza de itens vazios que não foram removidos por exclusão
      for (let i = 0; i < this.itemList.length; i++) {
        if(this.itemList[i].estoque) {
          for (let j = 0; j < this.itemList[i].estoque.length; j++) {
            
            // Remover itens que são marcados como excluídos mas não tem codnfqt
            if (this.itemList[i].estoque[j].excluido && !this.itemList[i].estoque[j].codnfqt) {
                this.itemList[i].estoque.splice(j, 1)
                j--; 
                continue;
            }

            if (!this.itemList[i].estoque[j].excluido &&
               (!this.itemList[i].estoque[j].qt || this.itemList[i].estoque[j].qt == 0) &&
               (!this.itemList[i].estoque[j].coddeposito || this.itemList[i].estoque[j].coddeposito == 0)) {
              this.itemList[i].estoque.splice(j, 1)
              j--; // Ajusta o index após o splice
            }
          }
        }
      }

      let sendData = {
        itens: this.itemList,
        concluir: this.concluir
      }

      this.msgErro = null
      this.msgConcluir = null

      if (this.notafiscal) {
        if (this.concluir) {
          const data = await apiORDSpost(this.$store, this.urlEstoque, null, 'put')
          return this.closeForm()
        }

        const data = await apiORDSpost(this.$store, this.urlEstoque, sendData, metodo)
        this.itemList = data.itens || data.items || data

        if (data.erros) {
          this.msgErro = 'Erro encontrado na validação dos produtos. Selecione o estoque para cada produto listado acima conforme a quantidade digitada na nota fiscal.'
          this.concluir = false
        } else {
          this.msgConcluir = 'Nota fiscal está pronta para ser baixada.'
          this.concluir = true
        }
      }

      if (this.pedido) {
        const data = await apiORDSpost(this.$store, this.urlEstoque, sendData, metodo)
        this.itemList = data.itens || data.items || data

        if (data.erros) {
          this.msgErro = 'Erro encontrado na alocação do pedido. Selecione o estoque para cada produto listado acima conforme a quantidade digitada no pedido.'
          this.concluir = false
        } else {
          if (this.concluir) {
            return this.closeForm()
          } else {
            this.msgConcluir = 'Pedido está pronto para ser alocado. Clique em "Concluir" novamente.'
            this.concluir = true
          }
        }
      }

      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })
    },

    async apiExcluirEstoque() {
      let metodo = 'post'
      await apiORDSpost(this.$store, this.urlExcluirEstoque, null, metodo)

      if (this.pedido)
        this.$erpToastSuccess('Alocação excluída')
      else if (this.notafiscal)
        this.$erpToastSuccess('Baixa da nota fiscal excluída')

      this.closeForm()
    },

    handleExcluir() {
      if (this.exclusaoConfirmada == 'S')
        this.apiExcluirEstoque()
      else {
        this.$erpToastError('Primeiro confirme a exclusão para continuar.')
      }
    },

    closeForm() {
      this.$emit('closeform')
    },

    async checkAutoAllocate() {
      let urlCheck = '';
      if (this.pedido) urlCheck = `estoque/pedidovenda/autoallocate/${this.index}`;
      if (this.notafiscal) urlCheck = `estoque/nfsaida/autoallocate/${this.index}`;

      const check = await apiORDS(this.$store.getters.urlOrds + urlCheck, null, true);

      if (check.autoAllocate !== 'S') {
        return;
      }

      await apiORDSpost(this.$store, this.urlSugestao, null, 'put');
      await this.loadData();

      let sendData = {
        itens: this.itemList,
        concluir: false
      };

      try {
        if (this.notafiscal) {
          const valData = await apiORDSpost(this.$store, this.urlEstoque, sendData, 'put');
          if (valData.erros) return;
          await apiORDSpost(this.$store, this.urlEstoque, null, 'put');
        } else if (this.pedido) {
          const valData = await apiORDSpost(this.$store, this.urlEstoque, sendData, 'put');
          if (valData.erros) return;
          sendData.concluir = true;
          await apiORDSpost(this.$store, this.urlEstoque, sendData, 'put');
        }

        this.$erpToastSuccess('Alocação executada com sucesso.');
        this.closeForm();
      } catch (e) {
        console.error(e);
      }
    }

  },

  mounted() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })
  },

  async created() {
    await this.loadData()
    if (!this.excluir) {
      this.checkAutoAllocate()
    }
  }
}
</script>

<style scoped>
.badge-success { background-color: #28a745 !important; }
.badge-warning { background-color: #ffc107 !important; color: #212529 !important; }

.main-screen {
  min-height: 80vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/forms-estoque/estoque-saida.vue